export default __webpack_public_path__ + "static/media/w-back.2bc9aad4.svg";